(function () {
  'use strict';

  const ROOT_SELECTOR = '[data-interior-proof]';
  const STATE_SELECTOR = '[data-interior-proof-state]';
  const BOOK_TITLE_SELECTOR = '[data-interior-proof-book-title]';
  const ORDER_LINE_SELECTOR = '[data-interior-proof-order-line]';
  const RETRY_BUTTON_SELECTOR = '[data-interior-proof-retry-button]';

  const VIEWER_SELECTOR = '[data-interior-proof-viewer]';
  const PAGE_TRIGGER_SELECTOR = '[data-interior-proof-page-trigger]';
  const SHARE_BUTTON_SELECTOR = '[data-interior-proof-share]';
  const PAGER_SELECTOR = '[data-interior-proof-pager]';
  const PAGER_TRACK_SELECTOR = '[data-interior-proof-pager-track]';
  const PAGER_PREV_SELECTOR = '[data-interior-proof-prev]';
  const PAGER_NEXT_SELECTOR = '[data-interior-proof-next]';

  const BOOK_SELECTOR = '[data-interior-proof-book]';
  const BOOK_HALF_LEFT_SELECTOR = '[data-interior-proof-half-left]';
  const BOOK_HALF_RIGHT_SELECTOR = '[data-interior-proof-half-right]';
  const BOOK_FLAP_SELECTOR = '[data-interior-proof-flap]';
  const BOOK_FLAP_FRONT_SELECTOR = '[data-interior-proof-flap-front]';
  const BOOK_FLAP_BACK_SELECTOR = '[data-interior-proof-flap-back]';
  const BOOK_CROSSFADE_SELECTOR = '[data-interior-proof-crossfade]';
  const COVER_LABELS_SELECTOR = '[data-interior-proof-cover-labels]';
  const LIVE_REGION_SELECTOR = '[data-interior-proof-live-region]';
  const SPINNER_SELECTOR = '[data-interior-proof-spinner]';

  // 2026-09-28 page-turn spec: 600ms desktop/tablet, 450ms <768px (both CHOSEN — the brief left
  // the exact number open, just an "~ms" range — and both eased with `ease-in-out`), 150ms for
  // the prefers-reduced-motion crossfade (the brief's own number, not chosen).
  const TURN_DURATION_MS = 600;
  const TURN_DURATION_MOBILE_MS = 450;
  const MOBILE_BREAKPOINT_PX = 768;

  // "Swipe (horizontal drag > 40px, mostly horizontal angle)" — the brief's own distance; the
  // angle threshold (dx > 1.5 * dy, ~34 degrees off horizontal) is CHOSEN.
  const SWIPE_MIN_DISTANCE_PX = 40;
  const SWIPE_MAX_SLOPE = 1.5;

  // "Never show an empty page during a turn (wait for load or short timeout)" — CHOSEN: long
  // enough for a same-region signed-URL fetch to normally finish, short enough that a genuinely
  // stuck image doesn't stall the turn the customer just asked for.
  const IMAGE_READY_TIMEOUT_MS = 800;

  const CHIPS_SELECTOR = '[data-interior-proof-chips]';
  const NOTE_TEXTAREA_SELECTOR = '[data-interior-proof-note-textarea]';
  const NOTE_COUNTER_SELECTOR = '[data-interior-proof-note-counter]';
  const NOTES_EMPTY_SELECTOR = '[data-interior-proof-notes-empty]';
  const NOTES_LABEL_SELECTOR = '[data-interior-proof-notes-label]';
  const NOTES_GROUP_SELECTOR = '[data-interior-proof-notes-group]';
  const NOTES_UNAVAILABLE_SELECTOR = '[data-interior-proof-notes-unavailable]';

  // 2026-10-01 ("the proof side column matches the design"): the collapsible that replaces the
  // always-open notes/Regenerations card. `request-changes` keeps its old name but not its old
  // job below 1024px — see handleStickyRequestChangesClick()'s own comment. `send-notes` is the
  // one genuinely new hook: the desktop button that opens the reject dialog, the job
  // `request-changes` used to do for both buttons at once before this task split them.
  const NOTES_TOGGLE_SELECTOR = '[data-interior-proof-notes-toggle]';
  const NOTES_PANEL_SELECTOR = '[data-interior-proof-notes-panel]';
  const NOTES_CAVEAT_SELECTOR = '[data-interior-proof-notes-caveat]';
  const VIEWED_COUNT_SELECTOR = '[data-interior-proof-viewed-count]';
  const VIEWED_FILL_SELECTOR = '[data-interior-proof-viewed-fill]';

  const REGEN_LINE_SELECTOR = '[data-interior-proof-regen-line]';
  const REQUEST_CHANGES_SELECTOR = '[data-interior-proof-request-changes]';
  const SEND_NOTES_SELECTOR = '[data-interior-proof-send-notes]';

  const LIGHTBOX_SELECTOR = '[data-interior-proof-lightbox]';
  const LIGHTBOX_INNER_SELECTOR = '[data-interior-proof-lightbox-inner]';
  const LIGHTBOX_CLOSE_SELECTOR = '[data-interior-proof-lightbox-close]';

  const APPROVE_DIALOG_SELECTOR = '[data-interior-proof-approve-dialog]';
  const APPROVE_TRIGGER_SELECTOR = '[data-interior-proof-approve-trigger]';
  const APPROVE_CANCEL_SELECTOR = '[data-interior-proof-approve-cancel]';
  const APPROVE_CONFIRM_SELECTOR = '[data-interior-proof-approve-confirm]';
  const APPROVE_ERROR_SELECTOR = '[data-interior-proof-approve-error]';

  const REJECT_DIALOG_SELECTOR = '[data-interior-proof-reject-dialog]';
  const REJECT_CANCEL_SELECTOR = '[data-interior-proof-reject-cancel]';
  const REJECT_FORM_SELECTOR = '[data-interior-proof-reject-form]';
  const REJECT_COMMENT_SELECTOR = '[data-interior-proof-reject-comment]';
  const REJECT_COUNTER_SELECTOR = '[data-interior-proof-reject-counter]';
  const REJECT_SEND_SELECTOR = '[data-interior-proof-reject-send]';
  const REJECT_ERROR_SELECTOR = '[data-interior-proof-reject-error]';
  const REJECT_INTRO_SELECTOR = '[data-interior-proof-reject-intro]';
  const REJECT_PAGES_LINE_SELECTOR = '[data-interior-proof-reject-pages-line]';

  const CONFIRMATION_DIALOG_SELECTOR = '[data-interior-proof-confirmation-dialog]';
  const CONFIRMATION_TITLE_SELECTOR = '[data-interior-proof-confirmation-title]';
  const CONFIRMATION_TEXT_SELECTOR = '[data-interior-proof-confirmation-text]';
  const CONFIRMATION_DONE_SELECTOR = '[data-interior-proof-confirmation-done]';

  const LOADING_MESSAGE_SELECTOR = '[data-interior-proof-loading-message]';

  // ADDENDUM, 2026-09-28: the two outcomes this page's actions can end in, with the exact title
  // text the addendum names for each ("Approved for print" / "Got it — we're redrawing").
  const APPROVE_CONFIRMATION_TITLE = 'Approved for print';
  const APPROVE_CONFIRMATION_TEXT =
    "Your book is on its way to print, and we'll email you a confirmation shortly.";
  const REJECT_CONFIRMATION_TITLE = "Got it — we're redrawing";
  const REJECT_CONFIRMATION_TEXT =
    "We're redrawing your book with your notes, and we'll email you once it's ready to review again.";

  // Product rule, 2026-09-28: "reject always needs one." The service enforces this too (the
  // sibling task makes an empty comment a 400) — this is the client-side half, so the customer
  // sees it before a round trip, not instead of the server-side one.
  const REJECT_COMMENT_MAX_LENGTH = 2000;

  // Per-page note limit, matching the service's own limit on each `pageNotes[].comment` entry
  // (2026-09-28 service task "a spreads note redraws only its page and reaches its prompt").
  // Independent of REJECT_COMMENT_MAX_LENGTH above, which caps the combined comment, not any one
  // page's note.
  const NOTE_MAX_LENGTH = 400;

  // 2026-09-29 task "the proof pages keep the footer down and load gently": both CHOSEN — the
  // brief gives the requirement ("after 6s", "60s") but calls both numbers out explicitly as
  // picked, not measured.
  const STILL_PREPARING_DELAY_MS = 6000;
  const REQUEST_TIMEOUT_MS = 60000;

  const LOADING_MESSAGE_INITIAL = 'Opening your book…';
  const LOADING_MESSAGE_STILL_PREPARING =
    'Still preparing your pages. The first visit can take a little longer.';

  // sessionStorage key prefix for the reload-survives-token addendum (2026-09-29, "a reload
  // breaks the page"). Namespaced by page ('interior-proof') so this page's and sheet-proof's
  // tokens can never collide even if the same personalizationId were ever reused across the two
  // (it never is, in practice, but the namespace costs nothing and removes the question).
  const TOKEN_STORAGE_PREFIX = 'storefront-proof:interior-proof:';

  // The statuses that mean "this proof is decided" for the addendum's "clear the stored token
  // once the proof is decided (approved, or rejected and accepted)" — deliberately not `expired`,
  // which is not a decision this customer made and which the addendum does not name.
  const DECIDING_STATUSES = ['approved', 'rejected_redrawing', 'rejected_with_team'];

  // The "honest copy" this constant used to hold ("We'll redraw the pages you left notes on. The
  // rest stay as they are.") now lives as a static sentence directly in the Liquid markup
  // (`.storefront-proof__notes-policy`, sections/interior-proof.liquid) — 2026-10-01 moved the
  // collapsible's numeric line to the brief's exact "{left} of {total} redraws left" format
  // (updateRedrawsLine()), which left this sentence with nothing left to be concatenated onto.
  // Static text needs no JS constant to drive it.

  // Fixed by the API contract this task builds against — the service side is being built in
  // parallel against the exact same paths. Do not change this without changing the contract.
  const API_PREFIX = '/apps/personalization/interior-proof/';

  // Task TL3. Same App Proxy host path and the same `?t=` token as every other GET on this page.
  // Contract: task S73 — a 1080x1080 JPEG, or 404 when there is no cover proof to build it from.
  const SHARE_API_PREFIX = '/apps/personalization/share-card/';
  const SHARE_CARD_FILE_NAME = 'everlasting-storybooks.jpg';

  // Containers that hold preview artwork. Listeners go on the container, not on each layer:
  // the halves, the flap faces and the crossfade come and go during a page turn, and the
  // hit-target button over them is disabled mid-turn, which suppresses its own mouse events.
  const PROTECTED_REGION_SELECTORS = [
    '.storefront-proof__book',
    '.storefront-proof__lightbox-inner'
  ];

  // assets/proof-protection.js, loaded immediately before this file by the same section. Both
  // are deferred, so script order is execution order and this is already defined.
  const Protection = window.ProofProtection;

  // assets/bot-trap.js (task TL4), loaded by this page's section before this file.
  const BotTrap = window.BotTrap;

  // Statuses the GET endpoint can report. Each one is also the `data-interior-proof-state`
  // name of its own container in the section markup, so setState(status) works directly for
  // every one of these without a translation table.
  const KNOWN_STATUSES = [
    'awaiting_decision',
    'approved',
    'rejected_redrawing',
    'rejected_with_team',
    'expired'
  ];

  /**
   * Display-only: a straight apostrophe renders with a visible gap in KoPub Batang (the title
   * font) — "Luna' s". Converts to the typographic right single quotation mark (U+2019) for
   * *display* only; the raw API value (`payload.bookTitle`) is never modified or re-sent
   * anywhere, since this page never writes the title back to the service. Checked in a real
   * browser that KoPub Batang Bold actually has this glyph (canvas render, non-blank) before
   * relying on it — see the run report.
   */
  function toDisplayTitle(text) {
    return typeof text === 'string' ? text.replace(/'/g, '’') : text;
  }

  /**
   * "Page 4" for one, "Pages 4 and 7" for two, "Pages 3, 4 and 7" for three or more — the exact
   * shape the task brief names ("Pages 4 and 7 will be redrawn"). `pageNumbers` is expected
   * already sorted ascending; this does not sort.
   */
  function formatPagesList(pageNumbers) {
    if (pageNumbers.length === 1) {
      return 'Page ' + pageNumbers[0];
    }

    const last = pageNumbers[pageNumbers.length - 1];
    const rest = pageNumbers.slice(0, -1);

    return 'Pages ' + rest.join(', ') + ' and ' + last;
  }

  class InteriorProofPage {
    constructor(root) {
      this.root = root;
      this.states = {};

      root.querySelectorAll(STATE_SELECTOR).forEach((el) => {
        this.states[el.dataset.interiorProofState] = el;
      });

      this.bookTitleEls = Array.from(root.querySelectorAll(BOOK_TITLE_SELECTOR));
      this.orderLineEl = root.querySelector(ORDER_LINE_SELECTOR);
      this.retryButton = root.querySelector(RETRY_BUTTON_SELECTOR);
      this.loadingMessageEl = root.querySelector(LOADING_MESSAGE_SELECTOR);
      this.loadingMessageTimer = null;

      this.viewerEl = root.querySelector(VIEWER_SELECTOR);
      this.pageTrigger = root.querySelector(PAGE_TRIGGER_SELECTOR);
      this.shareButton = root.querySelector(SHARE_BUTTON_SELECTOR);
      this.pagerEl = root.querySelector(PAGER_SELECTOR);
      this.pagerTrackEl = root.querySelector(PAGER_TRACK_SELECTOR);
      this.pagerPrevButton = root.querySelector(PAGER_PREV_SELECTOR);
      this.pagerNextButton = root.querySelector(PAGER_NEXT_SELECTOR);

      this.bookEl = root.querySelector(BOOK_SELECTOR);
      this.halfLeftEl = root.querySelector(BOOK_HALF_LEFT_SELECTOR);
      this.halfRightEl = root.querySelector(BOOK_HALF_RIGHT_SELECTOR);
      this.flapEl = root.querySelector(BOOK_FLAP_SELECTOR);
      this.flapFrontEl = root.querySelector(BOOK_FLAP_FRONT_SELECTOR);
      this.flapBackEl = root.querySelector(BOOK_FLAP_BACK_SELECTOR);
      this.crossfadeEl = root.querySelector(BOOK_CROSSFADE_SELECTOR);
      this.coverLabelsEl = root.querySelector(COVER_LABELS_SELECTOR);
      this.liveRegionEl = root.querySelector(LIVE_REGION_SELECTOR);
      this.spinnerEl = root.querySelector(SPINNER_SELECTOR);

      // Page-turn state. `turning` plus "at most one queued turn" (`pendingTargetIndex`) is the
      // whole click-queue: a click while `turning` is true sets `pendingTargetIndex` if and only
      // if it is still null; every click after that first one is dropped on the floor, per the
      // brief ("a click during a turn queues at most one more turn, further clicks ignored").
      this.turning = false;
      this.inFlightTargetIndex = null;
      this.pendingTargetIndex = null;
      this.pendingTurn = null;
      this.preloadedUrls = new Set();
      this.retriedImageUrls = new Set();

      // TL13: urls whose load has finally failed (after loadImageWithRecovery's own
      // refresh-and-retry gave up). syncSpinner() reads this so a dead image ends the spinner
      // instead of spinning forever -- the brief's "never an endless spinner".
      this.failedImageUrls = new Set();
      // 2026-09-28: the stage-fit CSS (--spread-ratio) needs the *decoded* pixel ratio, not the
      // API's declared width/height — populated alongside `preloadedUrls` every time an Image()
      // probe (preload, or loadImageWithRecovery during a turn) actually finishes loading, so it
      // costs no extra request. Keyed by imageUrl, same as preloadedUrls.
      this.spreadDimensionsByUrl = new Map();
      this.swipeActive = false;
      this.swipeStartX = 0;
      this.swipeStartY = 0;

      this.chipsEl = root.querySelector(CHIPS_SELECTOR);
      this.noteTextarea = root.querySelector(NOTE_TEXTAREA_SELECTOR);
      this.noteCounterEl = root.querySelector(NOTE_COUNTER_SELECTOR);
      this.notesEmptyEl = root.querySelector(NOTES_EMPTY_SELECTOR);
      this.notesLabelEl = root.querySelector(NOTES_LABEL_SELECTOR);
      this.notesGroupEl = root.querySelector(NOTES_GROUP_SELECTOR);
      this.notesUnavailableEl = root.querySelector(NOTES_UNAVAILABLE_SELECTOR);

      // The collapsible. `notesOpen` is the one source of truth setNotesOpen() writes to both
      // the toggle's aria-expanded and the panel's hidden attribute from — never read either of
      // those back to ask "is it open", always this field.
      this.notesToggle = root.querySelector(NOTES_TOGGLE_SELECTOR);
      this.notesPanel = root.querySelector(NOTES_PANEL_SELECTOR);
      this.notesCaveatEl = root.querySelector(NOTES_CAVEAT_SELECTOR);
      this.notesOpen = false;

      // "Spreads viewed X / N" — X is this.viewedSpreadNumbers.size, built by
      // afterSpreadChanged(); N is this.items.length (2026-10-05: includes the cover, when one
      // exists — see trackViewedSpread()'s own comment). CHOSEN (brief): does not gate Approve,
      // which reads nothing from this state.
      this.viewedCountEl = root.querySelector(VIEWED_COUNT_SELECTOR);
      this.viewedFillEl = root.querySelector(VIEWED_FILL_SELECTOR);
      this.viewedSpreadNumbers = new Set();

      this.regenLineEl = root.querySelector(REGEN_LINE_SELECTOR);
      // Two different buttons now, where one attribute used to cover both (see
      // NOTES_TOGGLE_SELECTOR's own comment above). Each is a single element, not an array —
      // exactly one of each exists per page, unlike approveTriggers below, which still
      // legitimately shares one attribute across two buttons because Approve's own behaviour
      // did not change between the two widths.
      this.requestChangesButton = root.querySelector(REQUEST_CHANGES_SELECTOR);
      this.sendNotesButton = root.querySelector(SEND_NOTES_SELECTOR);

      // The fetched spreads, sorted, plus which one is on screen — replaces the old
      // spreadsByNumber map now that there is one viewer instead of a 12-item grid.
      this.spreads = [];
      this.currentIndex = 0;

      // 2026-10-05 ("the spreads page shows the cover first"): `this.cover` is the raw
      // `payload.cover` object (or null — absent and null are treated identically, see
      // applyStatusPayload), `this.items` is the navigation list the viewer, pager, keyboard,
      // preloader and "seen" counter all actually walk — the cover (if any) first, then every
      // spread in `this.spreads`' own order. Rebuilt by rebuildItems() any time `this.cover` or
      // `this.spreads` changes (applyStatusPayload, refreshSpreadUrls) — never mutated directly.
      // `this.currentIndex` indexes INTO `this.items` now, not into `this.spreads` — the cover
      // sitting at index 0 when present is what makes "cover first" fall out of the existing
      // index-0-on-load behaviour for free, with no separate "show the cover" code path.
      this.cover = null;
      this.items = [];

      // Per-page notes, in memory only, per the brief — never sent anywhere until "Request
      // changes" builds the combined comment from whatever is in this Map at that moment.
      // Cover notes are NOT stored here: `this.coverNote` (below) is a separate, single string,
      // because the contract sends it as its own top-level `coverNote` field, not one more
      // `pageNotes[]` entry — there is no spreadNumber to key it by.
      this.notes = new Map();

      // "Only when notesAccepted is true: the cover gets a note field like a spread" — a plain
      // string, not part of the Map above, synced by syncNoteTextarea()/handleNoteInput() exactly
      // like a spread's note whenever the current item is the cover.
      this.coverNote = '';

      this.redrawsLeft = null;
      this.redrawsTotal = null;

      this.lightbox = root.querySelector(LIGHTBOX_SELECTOR);
      this.lightboxInner = root.querySelector(LIGHTBOX_INNER_SELECTOR);
      this.lightboxCloseButton = root.querySelector(LIGHTBOX_CLOSE_SELECTOR);
      this.lightboxOpener = null;

      this.approveDialog = root.querySelector(APPROVE_DIALOG_SELECTOR);
      // Two triggers share this attribute — the desktop-only inline button and the mobile
      // sticky-bar button (only one of the two is ever visible at a given width, via CSS).
      this.approveTriggers = Array.from(root.querySelectorAll(APPROVE_TRIGGER_SELECTOR));
      this.approveCancelButton = root.querySelector(APPROVE_CANCEL_SELECTOR);
      this.approveConfirmButton = root.querySelector(APPROVE_CONFIRM_SELECTOR);
      this.approveError = root.querySelector(APPROVE_ERROR_SELECTOR);
      this.approveInFlight = false;

      this.rejectDialog = root.querySelector(REJECT_DIALOG_SELECTOR);
      this.rejectCancelButton = root.querySelector(REJECT_CANCEL_SELECTOR);
      this.rejectForm = root.querySelector(REJECT_FORM_SELECTOR);
      this.rejectComment = root.querySelector(REJECT_COMMENT_SELECTOR);
      this.rejectCounter = root.querySelector(REJECT_COUNTER_SELECTOR);
      this.rejectSendButton = root.querySelector(REJECT_SEND_SELECTOR);
      this.rejectError = root.querySelector(REJECT_ERROR_SELECTOR);
      this.rejectIntroEl = root.querySelector(REJECT_INTRO_SELECTOR);
      this.rejectPagesLineEl = root.querySelector(REJECT_PAGES_LINE_SELECTOR);
      this.rejectInFlight = false;

      this.confirmationDialog = root.querySelector(CONFIRMATION_DIALOG_SELECTOR);
      this.confirmationTitleEl = root.querySelector(CONFIRMATION_TITLE_SELECTOR);
      this.confirmationTextEl = root.querySelector(CONFIRMATION_TEXT_SELECTOR);
      this.confirmationDoneButton = root.querySelector(CONFIRMATION_DONE_SELECTOR);
      // Set right before showModal(), read by handleConfirmationDialogClose() once the dialog's
      // native `close` event fires — the same event fires whether Done was clicked or Escape was
      // pressed, so one listener covers both (addendum: "Escape closes it").
      this.pendingDecidedStatus = null;

      /**
       * Read once, here, and never again from `window.location` — the token is a bearer
       * credential for this one proof, not an id. Kept as an instance field (memory), never
       * written to a DOM attribute (a data attribute is as readable by a page-scanning extension
       * or a third-party script as a global variable would be), never to localStorage, a cookie,
       * or the DOM, and never passed to console.* — see the deliberately token-free console.warn
       * calls below.
       *
       * ADDENDUM, 2026-09-29 ("a reload breaks the page"): `t` alone, kept only in memory, does
       * not survive a reload in the same tab, and this page's own `t`-stripping (below) means the
       * *second* load has nothing to read — it landed in missing-params even though the customer
       * had done nothing wrong. The rule now: `t` from the URL always wins and is stored, in
       * sessionStorage only, keyed to this exact `p` (readToken()/storeToken() below); only when
       * the URL has no `t` at all is the stored one read back, and only for this same `p` — a
       * token stored for a different `p` is never read (see storageKeyFor()). sessionStorage is
       * per tab and dies with it, unlike localStorage or a cookie, which is why it's the one used.
       * Every sessionStorage access is wrapped in try/catch; if it throws (private mode, blocked
       * storage), this falls back to today's behavior — no token, no state, than a missing-params
       * page on reload, exactly as before this addendum.
       */
      const params = new URLSearchParams(window.location.search);
      this.personalizationId = params.get('p');
      let token = params.get('t');

      if (token) {
        this.storeToken(this.personalizationId, token);
      } else if (this.personalizationId) {
        token = this.readToken(this.personalizationId);
      }

      this.token = token;

      // Strip the token from the address bar before doing anything else network-related —
      // every extra millisecond it sits in `location.search` is a millisecond a screen share,
      // a browser extension, or shoulder-surfing the URL bar can read it. `p` stays: it is a
      // plain identifier, not a credential, and keeping it lets the customer see which
      // personalization this tab is for. Stripped whenever the URL had one, whether or not it
      // matched what's already stored — the address bar must never carry `t`, independent of the
      // storage/token logic above.
      if (params.get('t')) {
        const url = new URL(window.location.href);
        url.searchParams.delete('t');
        window.history.replaceState(null, '', url.pathname + url.search + url.hash);
      }

      this.handleRetryClick = this.handleRetryClick.bind(this);
      this.handlePageTriggerClick = this.handlePageTriggerClick.bind(this);
      this.handlePrevClick = this.handlePrevClick.bind(this);
      this.handleNextClick = this.handleNextClick.bind(this);
      this.handlePagerClick = this.handlePagerClick.bind(this);
      this.handleChipClick = this.handleChipClick.bind(this);
      this.handleNoteInput = this.handleNoteInput.bind(this);
      this.handleNotesToggleClick = this.handleNotesToggleClick.bind(this);
      this.handleStickyRequestChangesClick = this.handleStickyRequestChangesClick.bind(this);
      this.handleRequestChangesClick = this.handleRequestChangesClick.bind(this);
      this.handleLightboxClick = this.handleLightboxClick.bind(this);
      this.handleApproveTriggerClick = this.handleApproveTriggerClick.bind(this);
      this.handleApproveConfirmClick = this.handleApproveConfirmClick.bind(this);
      this.handleRejectCommentInput = this.handleRejectCommentInput.bind(this);
      this.handleRejectSubmit = this.handleRejectSubmit.bind(this);
      this.handleConfirmationDialogClose = this.handleConfirmationDialogClose.bind(this);
      this.handleWindowResize = this.handleWindowResize.bind(this);
      this.handleFlapTransitionEnd = this.handleFlapTransitionEnd.bind(this);
      this.handleViewerKeyDown = this.handleViewerKeyDown.bind(this);
      this.handleBookPointerDown = this.handleBookPointerDown.bind(this);
      this.handleBookPointerUp = this.handleBookPointerUp.bind(this);
      this.handleBookPointerCancel = this.handleBookPointerCancel.bind(this);

      this.init();
    }

    init() {
      if (this.retryButton) {
        this.retryButton.addEventListener('click', this.handleRetryClick);
      }

      // Recomputes the pager's scroll-fade (fix #5) if the viewport crosses the 1024px
      // breakpoint (fix #4 removes scrolling entirely above it) — e.g. rotating a tablet.
      window.addEventListener('resize', this.handleWindowResize);

      if (this.pageTrigger) {
        this.pageTrigger.addEventListener('click', this.handlePageTriggerClick);
      }

      if (this.pagerPrevButton) {
        this.pagerPrevButton.addEventListener('click', this.handlePrevClick);
      }

      if (this.pagerNextButton) {
        this.pagerNextButton.addEventListener('click', this.handleNextClick);
      }

      if (this.pagerEl) {
        this.pagerEl.addEventListener('click', this.handlePagerClick);
      }

      if (this.flapEl) {
        this.flapEl.addEventListener('transitionend', this.handleFlapTransitionEnd);
      }

      // "ArrowLeft/ArrowRight when the viewer is focused" — scoped to this container (the book,
      // its pager, its nav buttons) so it never hijacks arrow keys typed into the notes textarea
      // or the chips, which live in the side panel, outside this element.
      if (this.viewerEl) {
        this.viewerEl.addEventListener('keydown', this.handleViewerKeyDown);
      }

      // Swipe: decided entirely from the total delta at pointerup, never during pointermove, and
      // no preventDefault is ever called — so vertical scrolling is never touched, let alone
      // blocked, by this listener. `touch-action: pan-y` on the book (CSS) tells the browser the
      // same thing for touch input specifically.
      if (this.bookEl) {
        this.bookEl.addEventListener('pointerdown', this.handleBookPointerDown);
        this.bookEl.addEventListener('pointerup', this.handleBookPointerUp);
        this.bookEl.addEventListener('pointercancel', this.handleBookPointerCancel);
      }

      if (this.chipsEl) {
        this.chipsEl.addEventListener('click', this.handleChipClick);
      }

      if (this.noteTextarea) {
        this.noteTextarea.addEventListener('input', this.handleNoteInput);
      }

      if (this.notesToggle) {
        this.notesToggle.addEventListener('click', this.handleNotesToggleClick);
      }

      if (this.requestChangesButton) {
        this.requestChangesButton.addEventListener('click', this.handleStickyRequestChangesClick);
      }

      if (this.sendNotesButton) {
        this.sendNotesButton.addEventListener('click', this.handleRequestChangesClick);
      }

      if (this.lightboxCloseButton) {
        this.lightboxCloseButton.addEventListener('click', () => this.closeLightbox());
      }

      if (this.lightbox) {
        this.lightbox.addEventListener('click', this.handleLightboxClick);
        this.lightbox.addEventListener('close', () => this.restoreFocusAfterLightbox());
      }

      this.approveTriggers.forEach((button) => {
        button.addEventListener('click', this.handleApproveTriggerClick);
      });

      if (this.approveCancelButton) {
        this.approveCancelButton.addEventListener('click', () => this.approveDialog.close());
      }

      if (this.approveConfirmButton) {
        this.approveConfirmButton.addEventListener('click', this.handleApproveConfirmClick);
      }

      if (this.rejectCancelButton) {
        this.rejectCancelButton.addEventListener('click', () => this.rejectDialog.close());
      }

      if (this.rejectForm) {
        this.rejectForm.addEventListener('submit', this.handleRejectSubmit);
      }

      if (this.rejectComment) {
        this.rejectComment.addEventListener('input', this.handleRejectCommentInput);
      }

      if (this.confirmationDoneButton) {
        this.confirmationDoneButton.addEventListener('click', () => this.confirmationDialog.close());
      }

      if (this.confirmationDialog) {
        this.confirmationDialog.addEventListener('close', this.handleConfirmationDialogClose);
      }

      this.installProtection();
      // setupShare() runs from applyStatusPayload, once the status response carries
      // `shareCardUrl` (S178: the card has its own read-only token; the proof token never
      // leaves this page).

      // No personalizationId, no token, or both — there is no request this page can make, and
      // nothing on it to recover with. Same terminal shape as photo-handoff's "no-token" state.
      if (!this.personalizationId || !this.token) {
        this.setState('missing-params');
        return;
      }

      this.checkStatus();
    }

    /**
     * Task TL3. Blocks the one-click ways to keep a preview; see assets/proof-protection.js for
     * what this deliberately does not claim to do.
     */
    installProtection() {
      Protection.protectRegions(this.root, PROTECTED_REGION_SELECTORS);
      Protection.installShortcutGuard(this.root, document);
    }

    /**
     * The share card is the one image the customer is meant to keep. The button starts hidden
     * and is revealed only once the endpoint has actually produced a card, so it is simply
     * absent while task S73 is undeployed and every call 404s.
     */
    setupShare() {
      if (this.share) {
        return;
      }
      if (!this.shareButton || !this.personalizationId || !this.shareCardUrl) {
        return;
      }

      this.share = Protection.createShareController({
        button: this.shareButton,
        url: this.buildShareCardUrl(),
        fileName: SHARE_CARD_FILE_NAME,
        fetch: (input, options) => window.fetch(input, options),
        navigator: window.navigator,
        document: document,
        FileCtor: window.File,
        createObjectURL: (blob) => window.URL.createObjectURL(blob),
        revokeObjectURL: (href) => window.URL.revokeObjectURL(href),
        onError: (reason) => console.warn('[interior-proof] Share card unavailable', { reason })
      });

      this.shareButton.addEventListener('click', () => this.share.share());
      this.share.probe();
    }

    buildShareCardUrl() {
      return this.shareCardUrl;
    }

    /**
     * ADDENDUM helpers, 2026-09-29. `personalizationId` is part of the key on purpose — a token
     * stored for `p=A` must never be read back for `p=B` (guard, this task's report). Every call
     * site wraps sessionStorage access in try/catch already via these three methods, so no other
     * method in this file needs its own try/catch for storage.
     */
    storageKeyFor(personalizationId) {
      return TOKEN_STORAGE_PREFIX + personalizationId;
    }

    storeToken(personalizationId, token) {
      if (!personalizationId || !token) {
        return;
      }

      try {
        window.sessionStorage.setItem(this.storageKeyFor(personalizationId), token);
      } catch (error) {
        // Storage unavailable (private mode, blocked, quota) — fall back to today's behavior: no
        // stored token, so a reload lands in missing-params exactly as it did before this
        // addendum.
      }
    }

    readToken(personalizationId) {
      try {
        return window.sessionStorage.getItem(this.storageKeyFor(personalizationId));
      } catch (error) {
        return null;
      }
    }

    /**
     * Called once the proof is decided (DECIDING_STATUSES, from revealDecidedState()) and on a
     * 401/403 status-check response (handleStatusError()) — addendum points 3 and the "when the
     * service answers 401/403 for it" guard. Never called for `expired`, which is not a decision
     * this customer made.
     */
    clearStoredToken() {
      if (!this.personalizationId) {
        return;
      }

      try {
        window.sessionStorage.removeItem(this.storageKeyFor(this.personalizationId));
      } catch (error) {
        // Nothing to clean up if storage was never reachable in the first place.
      }
    }

    /**
     * 2026-09-29: the loading-state requirements (skeleton, aria-busy, the 6s "still preparing"
     * message) all key off whichever state is showing, not off a separate flag — this is the one
     * place every state transition passes through, so it is the one place that manages both.
     */
    setState(name) {
      Object.keys(this.states).forEach((key) => {
        const el = this.states[key];

        if (el) {
          el.hidden = key !== name;
        }
      });

      // TASK TL4: the minimum-time clock starts when there is actually something to decide on,
      // not at page load — the status GET can take seconds before this state appears.
      if (name === 'awaiting_decision') {
        BotTrap.markOpened(this.root, Date.now());
      }

      this.root.setAttribute('aria-busy', name === 'loading' ? 'true' : 'false');

      if (name === 'loading') {
        this.startLoadingMessageTimer();
      } else {
        this.clearLoadingMessageTimer();
      }
    }

    startLoadingMessageTimer() {
      if (!this.loadingMessageEl) {
        return;
      }

      this.loadingMessageEl.textContent = LOADING_MESSAGE_INITIAL;
      window.clearTimeout(this.loadingMessageTimer);

      this.loadingMessageTimer = window.setTimeout(() => {
        this.loadingMessageEl.textContent = LOADING_MESSAGE_STILL_PREPARING;
      }, STILL_PREPARING_DELAY_MS);
    }

    clearLoadingMessageTimer() {
      window.clearTimeout(this.loadingMessageTimer);
      this.loadingMessageTimer = null;
    }

    /**
     * ADDENDUM, 2026-09-28 (owner report, order #41022): switches to a decided state (approved,
     * rejected_redrawing, rejected_with_team, expired) AND brings it into view — the owner
     * approved the live sheet page while scrolled down, and the confirmation text landed off
     * screen above him. Called both right after the confirmation dialog closes and whenever a
     * fresh page load lands directly in one of these states (see applyStatusPayload below), so
     * "the customer must see it at once" holds for both routes into a decided state, not just one.
     */
    revealDecidedState(status) {
      // ADDENDUM, 2026-09-29: "clear the stored token once the proof is decided (approved, or
      // rejected and accepted)" — this is the one function both routes into a decided state run
      // through (a fresh GET landing here directly, or the confirmation dialog closing after a
      // successful approve/reject), so it is the one place this needs to happen. Not called for
      // `expired`, which DECIDING_STATUSES deliberately excludes.
      if (DECIDING_STATUSES.includes(status)) {
        this.clearStoredToken();
      }

      this.setState(status);

      const el = this.states[status];

      if (!el) {
        return;
      }

      const heading = el.querySelector('.storefront-proof__title');

      if (heading) {
        if (!heading.hasAttribute('tabindex')) {
          heading.setAttribute('tabindex', '-1');
        }

        heading.focus({ preventScroll: true });
      }

      el.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }

    /**
     * ADDENDUM point 1: opens only from a successful approve/reject response — never called from
     * a 4xx/5xx/409 branch, which keep calling checkStatus()/showApproveError()/showRejectError()
     * exactly as before. `status` is applied once the dialog closes (Done or Escape — see
     * handleConfirmationDialogClose), not immediately, so the decision form stays visible for as
     * long as the confirmation is open rather than swapping underneath it.
     */
    showConfirmationDialog(title, text, status) {
      this.pendingDecidedStatus = status;

      if (!this.confirmationDialog) {
        this.revealDecidedState(status);
        return;
      }

      this.confirmationTitleEl.textContent = title;
      this.confirmationTextEl.textContent = text;
      this.confirmationDialog.showModal();
    }

    /**
     * Native `<dialog>`'s `close` event fires the same way for the Done button and for Escape, so
     * this one listener satisfies "Escape closes it" for free — no separate keydown handling.
     */
    handleConfirmationDialogClose() {
      const status = this.pendingDecidedStatus;
      this.pendingDecidedStatus = null;

      if (status) {
        this.revealDecidedState(status);
      }
    }

    setBookTitle(bookTitle) {
      const text = toDisplayTitle(bookTitle || 'Your storybook');

      this.bookTitleEls.forEach((el) => {
        el.textContent = text;
      });
    }

    /**
     * Contract fix, 2026-09-29 (service commit 4dd2944): `payload.orderName` is the bare
     * Shopify order name, e.g. orderName: '#41022' — not a pre-formatted string. This builds
     * the display line ("Order #41022 · Proof review") client-side. Hidden for any non-string
     * or empty value, which is also the correct behavior when the field isn't populated yet.
     */
    setOrderName(orderName) {
      if (!this.orderLineEl) {
        return;
      }

      if (typeof orderName !== 'string' || orderName === '') {
        this.orderLineEl.hidden = true;
        this.orderLineEl.textContent = '';
        return;
      }

      this.orderLineEl.textContent = `Order ${orderName} · Proof review`;
      this.orderLineEl.hidden = false;
    }

    buildStatusUrl() {
      const path = API_PREFIX + encodeURIComponent(this.personalizationId);
      return path + '?t=' + encodeURIComponent(this.token);
    }

    /**
     * TASK TL4 appends the two bot signals here. They are QUERY parameters because the service's
     * global ValidationPipe runs `forbidNonWhitelisted: true` and would 400 on unknown BODY
     * fields, and the elapsed time is named `bt`, not `t`, because `t` on these routes is
     * already the auth token (`@Query('t') token`). Both measured — see the run report.
     */
    buildActionUrl(action) {
      const path = API_PREFIX + encodeURIComponent(this.personalizationId) + '/' + action;
      const url = path + '?t=' + encodeURIComponent(this.token);
      return BotTrap.appendSignals(url, this.botTrapVerdict || { hp: '', elapsed: 0 });
    }

    /**
     * 2026-09-29: "the loading state always ends" — a request that has not answered after 60s
     * (CHOSEN, REQUEST_TIMEOUT_MS) is aborted, which rejects the fetch below exactly like any
     * other failed send and lands in the existing `catch` block, the same network-error state a
     * genuine connectivity failure already used. No separate "timed out" message or state.
     */
    async checkStatus() {
      this.setState('loading');

      let response;
      const timeoutController = new AbortController();
      const timeoutTimer = window.setTimeout(() => timeoutController.abort(), REQUEST_TIMEOUT_MS);

      try {
        response = await fetch(this.buildStatusUrl(), {
          method: 'GET',
          headers: { Accept: 'application/json' },
          signal: timeoutController.signal
        });
      } catch (error) {
        console.warn('[interior-proof] Status check failed to send', { message: error?.message || null });
        this.setState('network-error');
        return;
      } finally {
        window.clearTimeout(timeoutTimer);
      }

      if (!response.ok) {
        this.handleStatusError(response.status);
        return;
      }

      let payload;

      try {
        payload = await response.json();
      } catch (error) {
        console.warn('[interior-proof] Status response was not valid JSON');
        this.setState('network-error');
        return;
      }

      this.applyStatusPayload(payload);
    }

    /**
     * 401/404/410 all mean the same thing to the customer: nothing this page can do fixes it,
     * and a retry would just repeat the same failure. The contract also names an `expired`
     * value inside a 200 body — both routes land on the same "expired" container so there is
     * one message for "this link no longer works", not two that happen to look identical.
     */
    handleStatusError(status) {
      console.warn('[interior-proof] Status check rejected', { status });

      // ADDENDUM guard, 2026-09-29: "when the service answers 401/403 for it" — cleared
      // independently of which UI state this maps to below (401 already lands on `expired`; 403
      // isn't otherwise distinguished here and falls into network-error, same as before).
      if (status === 401 || status === 403) {
        this.clearStoredToken();
      }

      if (status === 401 || status === 404 || status === 410) {
        this.revealDecidedState('expired');
        return;
      }

      this.setState('network-error');
    }

    applyStatusPayload(payload) {
      const status = payload && payload.status;

      if (!KNOWN_STATUSES.includes(status)) {
        console.warn('[interior-proof] Status response had an unrecognized status');
        this.setState('network-error');
        return;
      }

      if (typeof payload.shareCardUrl === 'string') {
        this.shareCardUrl = payload.shareCardUrl;
        this.setupShare();
      }

      if (status === 'awaiting_decision') {
        this.setBookTitle(payload.bookTitle);
        this.setOrderName(payload.orderName);

        this.spreads = (Array.isArray(payload.spreads) ? payload.spreads.slice() : []).sort(
          (a, b) => a.spreadNumber - b.spreadNumber
        );
        // Contract (service S13): `cover` is absent until S13 ships, and explicitly nullable
        // after that — both mean "no cover", same as each other, never distinguished.
        this.cover = payload && payload.cover ? payload.cover : null;
        this.rebuildItems();
        this.currentIndex = 0;
        this.notes = new Map();
        this.coverNote = '';
        this.viewedSpreadNumbers = new Set();
        this.setNotesOpen(false);
        this.redrawsLeft = typeof payload.redrawsLeft === 'number' ? payload.redrawsLeft : null;
        this.redrawsTotal = typeof payload.redrawsTotal === 'number' ? payload.redrawsTotal : null;

        this.renderViewer();
        this.updateNotesEmptyHint();
        this.updateRedrawsLine();
        this.updateRequestChangesButtons();
        this.updateSendNotesCaveat();
        this.setState('awaiting_decision');
        return;
      }

      if (status === 'approved' || status === 'rejected_redrawing' || status === 'rejected_with_team') {
        this.setBookTitle(payload.bookTitle);
      }

      // ADDENDUM point 2: "whenever the page loads in a decided state" — a fresh GET landing
      // directly on approved/rejected_redrawing/rejected_with_team/expired gets the same
      // reveal-and-scroll treatment as closing the confirmation dialog does.
      this.revealDecidedState(status);
    }

    /**
     * 2026-10-05 ("the spreads page shows the cover first"): the one place `this.items` is ever
     * written. Cover first (when present), then every spread in `this.spreads`' own order — never
     * reordered beyond that, so "cover first" is simply index 0 existing or not. Called from
     * applyStatusPayload() (fresh data) and refreshSpreadUrls() (a signed-URL refresh mid-turn) —
     * both already hold the fresh `this.cover`/`this.spreads` before calling this.
     */
    rebuildItems() {
      const items = [];

      if (this.cover) {
        items.push({
          kind: 'cover',
          imageUrl: this.cover.imageUrl,
          width: this.cover.width,
          height: this.cover.height,
          shape: this.cover.shape,
          notesAccepted: !!this.cover.notesAccepted
        });
      }

      this.spreads.forEach((spread) => {
        items.push({
          kind: 'spread',
          spreadNumber: spread.spreadNumber,
          imageUrl: spread.imageUrl,
          width: spread.width,
          height: spread.height
        });
      });

      this.items = items;
    }

    /**
     * Re-resolves an item by its identity (kind, plus spreadNumber for a spread) rather than by
     * array position or object reference — the same defensive shape startTurn()/
     * loadImageWithRecovery() already used for spreads alone (a refresh replaces array entries by
     * identity), generalized so the cover gets the identical guarantee ("image recovery … treats
     * the cover as one more item"). There is at most one cover, so `kind === 'cover'` alone
     * resolves it.
     */
    resolveItemByRef(kind, spreadNumber) {
      if (kind === 'cover') {
        return this.items.find((item) => item.kind === 'cover');
      }

      return this.items.find((item) => item.kind === 'spread' && item.spreadNumber === spreadNumber);
    }

    /**
     * (Re)builds the book at rest, with no animation: both static halves show the current
     * spread, the flap and crossfade layers are hidden, and any in-flight turn bookkeeping is
     * cleared. Called once the spreads first load (from applyStatusPayload) — every navigation
     * after that goes through requestTurn()/playTurn()/playCrossfade() instead, which call
     * afterSpreadChanged() (the second half of what this method used to do) directly so a turn
     * never has to re-run the parts of this method that would restate the current spread.
     */
    renderViewer() {
      const item = this.items[this.currentIndex];

      if (item) {
        // `--spread-ratio` (consumed by `aspect-ratio` and the >=1024px stage width formula in
        // storefront-proof.css) comes from the *decoded* image, not the API's declared
        // width/height — see updateSpreadRatio()'s comment for why. `updateSpreadRatio` applies
        // whatever is already cached; fadeInHalves() below kicks off the first, uncached load and
        // applies both the dimensions and the background once it resolves (every navigation after
        // this one goes through loadImageWithRecovery instead, which already awaits the load
        // before this point, so this fire-and-forget path only matters for the very first item
        // shown on page load — the cover when one exists, spread 1 otherwise).
        this.updateSpreadRatio(item);
        this.fadeInHalves(item);
      } else {
        this.clearHalfBackground(this.halfLeftEl);
        this.clearHalfBackground(this.halfRightEl);
      }

      if (this.flapEl) {
        this.flapEl.hidden = true;
        this.flapEl.classList.remove(
          'storefront-proof__book-flap--turning',
          'storefront-proof__book-flap--next',
          'storefront-proof__book-flap--prev'
        );
        this.flapEl.style.willChange = '';
      }

      if (this.crossfadeEl) {
        this.crossfadeEl.hidden = true;
        this.crossfadeEl.classList.remove('storefront-proof__book-crossfade--visible');
        this.crossfadeEl.style.willChange = '';
      }

      this.turning = false;
      this.inFlightTargetIndex = null;
      this.pendingTargetIndex = null;
      this.pendingTurn = null;

      if (this.pageTrigger) {
        this.pageTrigger.disabled = false;
      }

      this.afterSpreadChanged();
    }

    setHalfBackground(el, imageUrl, position) {
      if (!el) {
        return;
      }

      el.style.backgroundImage = 'url("' + imageUrl + '")';
      el.style.backgroundPosition = position;
    }

    clearHalfBackground(el) {
      if (!el) {
        return;
      }

      el.style.backgroundImage = 'none';
    }

    /**
     * Everything that must stay in sync with `this.currentIndex` once it changes, whichever way
     * it changed (initial render, a completed turn, or the reduced-motion crossfade): Prev/Next
     * disabled state, the pager row, the notes textarea, the accessible name/live-region
     * announcement, and kicking off preloads of the new neighbours.
     */
    afterSpreadChanged() {
      const item = this.items[this.currentIndex];

      if (this.pagerPrevButton) {
        this.pagerPrevButton.disabled = this.currentIndex <= 0;
      }

      if (this.pagerNextButton) {
        this.pagerNextButton.disabled = this.currentIndex >= this.items.length - 1;
      }

      this.renderPagerNumbers();
      this.syncNoteTextarea();
      this.updateBookAccessibility(item);
      this.updateNotesLabel(item);
      this.updateCoverPresentation(item);
      this.trackViewedSpread(item);
      this.preloadNeighbors();
      this.syncSpinner();
    }

    /**
     * 2026-10-05 ("the spreads page shows the cover first"): everything that depends on WHICH
     * KIND of item is on screen, not just which index — the spine hairline (a real book gutter
     * only exists between two spread halves, never across a cover), the wraparound-only
     * "Back cover"/"Front cover" labels, and which of the notes-group/notes-unavailable pair is
     * shown (product rule: "no note field on the cover" unless `notesAccepted` is true).
     */
    updateCoverPresentation(item) {
      const isCover = !!(item && item.kind === 'cover');

      if (this.bookEl) {
        this.bookEl.classList.toggle('storefront-proof__book--cover', isCover);
      }

      if (this.coverLabelsEl) {
        this.coverLabelsEl.hidden = !(isCover && item.shape === 'wraparound');
      }

      const notesAvailable = !isCover || !!(item && item.notesAccepted);

      if (this.notesGroupEl) {
        this.notesGroupEl.hidden = !notesAvailable;
      }

      if (this.notesUnavailableEl) {
        this.notesUnavailableEl.hidden = notesAvailable;
      }
    }

    /**
     * 2026-09-29 ("the Approve button is where the decision is"), item 3: the notes panel names
     * the page it belongs to, since Approve (the decision card, above it) is for the whole book.
     * 2026-10-01: fills one `<span>` inside the panel's own "Notes for …" heading, rather than a
     * separate paragraph shown/hidden on its own — the heading is always there, it simply has no
     * text in it until the first item loads.
     *
     * 2026-10-05 ("the spreads page shows the cover first"): the span now holds the WHOLE variable
     * phrase ("spread 4", "the cover"), not just a trailing number — the heading's static prefix
     * is only "Notes for " now, where it used to be "Notes for spread ". For every spread this
     * renders the exact same text as before ("Notes for " + "spread 4" === the old "Notes for
     * spread " + "4"); only the cover branch is new.
     */
    updateNotesLabel(item) {
      if (!this.notesLabelEl) {
        return;
      }

      if (!item) {
        this.notesLabelEl.textContent = '';
        return;
      }

      this.notesLabelEl.textContent = item.kind === 'cover' ? 'the cover' : 'spread ' + item.spreadNumber;
    }

    /**
     * "Spreads viewed X / N" (2026-10-01 task "the proof side column matches the design"). X
     * counts items actually shown in THIS page session — this method is the one place that is
     * decided, because afterSpreadChanged() is the one place every navigation (the initial
     * render via renderViewer(), and every turn after it) already converges on, whichever way the
     * index changed.
     *
     * 2026-10-05: "the seen counting … treat[s] the cover as one more item" — the cover (keyed by
     * the sentinel string `'cover'`, which can never collide with a numeric spreadNumber) now
     * counts toward both X and N alike. N is `this.items.length`, read fresh each time rather than
     * cached, so it is never stale against whatever the API actually returned. The card's own
     * static "Spreads viewed" label is unchanged by this task — see the run report.
     */
    trackViewedSpread(item) {
      if (!item) {
        return;
      }

      this.viewedSpreadNumbers.add(item.kind === 'cover' ? 'cover' : item.spreadNumber);
      this.updateViewedProgress();
    }

    updateViewedProgress() {
      const total = this.items.length;
      const viewed = Math.min(this.viewedSpreadNumbers.size, total);

      if (this.viewedCountEl) {
        this.viewedCountEl.textContent = viewed + ' / ' + total;
      }

      if (this.viewedFillEl) {
        const pct = total > 0 ? (viewed / total) * 100 : 0;
        this.viewedFillEl.style.width = pct + '%';
      }
    }

    /**
     * Accessibility, 2026-09-28: the hit-target's accessible name and an aria-live="polite"
     * announcement both read "Spread N of 12" after a turn completes (or the initial render) —
     * never mid-turn, since this is only ever called from afterSpreadChanged(), which itself only
     * runs once `this.currentIndex` has already landed on the new value.
     *
     * 2026-10-05: the cover branch is new; the spread branch's own strings are byte-identical to
     * before ("keep the spread labels … exactly as they are", brief).
     */
    updateBookAccessibility(item) {
      if (!item) {
        return;
      }

      const isCover = item.kind === 'cover';
      const label = isCover ? 'Cover' : 'Spread ' + item.spreadNumber + ' of ' + this.spreads.length;

      if (this.pageTrigger) {
        this.pageTrigger.setAttribute(
          'aria-label',
          isCover ? 'Open the cover large' : 'Open this spread large — ' + label
        );
      }

      if (this.liveRegionEl) {
        this.liveRegionEl.textContent = label;
      }
    }

    getTurnDurationMs() {
      return window.innerWidth < MOBILE_BREAKPOINT_PX ? TURN_DURATION_MOBILE_MS : TURN_DURATION_MS;
    }

    prefersReducedMotion() {
      return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    }

    /**
     * `.storefront-proof__book`'s `aspect-ratio: var(--spread-ratio, 1.9697)` (in
     * assets/storefront-proof.css) needs the *displayed* spread's real ratio, read from the
     * decoded image rather than trusting the API's declared width/height. Set on
     * `.storefront-proof__viewer` rather than on the book element itself — book is a descendant
     * of viewer, and a plain assignment here would work either way today, but keeping the ratio
     * on the ancestor is what let an earlier layout (a sibling "stage" wrapper, since removed)
     * share it with more than one descendant; kept here since nothing forces it back onto book
     * and it costs nothing extra. Applies a cached, already-decoded naturalWidth/naturalHeight if
     * one exists for this spread's URL; otherwise leaves whatever value is already set (the CSS
     * fallback on first paint, or the previous spread's ratio on a navigation) rather than
     * resetting it — every spread shares one physical trim size in practice, so a
     * stale-but-plausible ratio beats snapping back to the fallback.
     */
    updateSpreadRatio(spread) {
      if (!this.viewerEl || !spread) {
        return;
      }

      const dims = this.spreadDimensionsByUrl.get(spread.imageUrl);

      if (dims && dims.width && dims.height) {
        this.viewerEl.style.setProperty('--spread-ratio', String(dims.width / dims.height));
      }
    }

    /**
     * 2026-09-29, "each image fades in when it has loaded": for the very first spread shown on
     * page load only (every navigation after this one goes through loadImageWithRecovery instead,
     * which already awaits the load before playTurn()/playCrossfade() call setHalfBackground()
     * directly — this method is not on that path and does not change it). Replaces the old
     * probeSpreadDimensions(), which only measured the decoded image; this also applies it, so
     * there is one Image() load per spread instead of two racing for the same URL.
     *
     * Until the image resolves, the halves keep `.storefront-proof__book-half`'s own placeholder
     * background (CSS) at opacity 0 — never a blank frame or a broken-image icon, since this is a
     * CSS background-image, not an `<img>`, and is never assigned before `onload`. On failure the
     * placeholder is simply left in place; there is no retry here (loadImageWithRecovery already
     * owns retry-on-failure, for turns, which this initial render is not).
     */
    fadeInHalves(item) {
      if (!item || !item.imageUrl) {
        return;
      }

      const apply = () => {
        this.setHalfBackground(this.halfLeftEl, item.imageUrl, '0% 0%');
        this.setHalfBackground(this.halfRightEl, item.imageUrl, '100% 0%');

        requestAnimationFrame(() => {
          [this.halfLeftEl, this.halfRightEl].forEach((el) => {
            if (el) {
              el.classList.add('storefront-proof__book-half--loaded');
            }
          });
        });
      };

      if (this.preloadedUrls.has(item.imageUrl)) {
        apply();
        return;
      }

      const img = new Image();

      img.onload = () => {
        this.preloadedUrls.add(item.imageUrl);
        this.spreadDimensionsByUrl.set(item.imageUrl, { width: img.naturalWidth, height: img.naturalHeight });
        this.syncSpinner();

        // Guards against the user having already navigated away before this fire-and-forget
        // initial load resolved — re-checks by the SAME item reference (cover or spread alike)
        // against whatever `this.items` now holds at the current index, not against `this.spreads`
        // (which never contains the cover).
        if (this.items[this.currentIndex] === item) {
          this.updateSpreadRatio(item);
          apply();
        }
      };

      // No retry here on purpose (see the docblock above) — the placeholder simply stays put,
      // which is still "never a blank frame or a broken-image icon", just not the real image.
      img.onerror = () => {
        // Still no retry and still no artwork change (see the docblock above) -- the placeholder
        // simply stays put. The one thing that must not stay put is the spinner.
        this.markImageFailed(item.imageUrl);
      };

      img.src = item.imageUrl;
    }

    /**
     * TL13: the spinner tracks exactly one fact -- whether the image for the item the customer
     * is looking at (or turning to) has finished decoding.
     *
     * Deriving it here, rather than toggling the element at each call site, is what makes it
     * correct across the two paths that can leave an undecoded frame on screen:
     *   - loadImageWithRecovery() resolves on IMAGE_READY_TIMEOUT_MS whether or not the image
     *     loaded, so startTurn() can play a turn onto an image that is still downloading;
     *   - fadeInHalves() is fire-and-forget for the very first item on page load.
     * Both end up back here, and both end up hidden by the same `preloadedUrls` membership that
     * already gates every other load decision on this page.
     *
     * getEffectiveIndex() is deliberate: mid-turn it returns the TARGET, so the spinner belongs
     * to the spread whose number the pager is already showing, not the one being turned away.
     */
    /**
     * TL13: records a url as unloadable and re-derives the spinner. Every image error path on
     * this page funnels through here so that "never an endless spinner" is a property of one
     * function rather than of each call site remembering to do it.
     */
    markImageFailed(imageUrl) {
      if (imageUrl) {
        this.failedImageUrls.add(imageUrl);
      }

      this.syncSpinner();
    }

    syncSpinner() {
      if (!this.spinnerEl) {
        return;
      }

      const item = this.items[this.getEffectiveIndex()];
      const waiting =
        Boolean(item && item.imageUrl) &&
        !this.preloadedUrls.has(item.imageUrl) &&
        !this.failedImageUrls.has(item.imageUrl);

      this.spinnerEl.hidden = !waiting;
    }

    /**
     * Preloads the immediate neighbours of the current spread so a turn to either one never has
     * to wait on the network. Best-effort and silent — a failure here just means the *next* turn
     * (not this preload) does its own load-with-recovery, see loadImageWithRecovery().
     */
    preloadNeighbors() {
      [this.items[this.currentIndex - 1], this.items[this.currentIndex + 1]].forEach((item) => {
        if (!item || this.preloadedUrls.has(item.imageUrl)) {
          return;
        }

        const img = new Image();
        img.onload = () => {
          this.preloadedUrls.add(item.imageUrl);
          this.spreadDimensionsByUrl.set(item.imageUrl, { width: img.naturalWidth, height: img.naturalHeight });
          // TL13: closes the race where a neighbour prefetch wins against the turn's own
          // loadImageWithRecovery() probe for the same url -- whichever lands first is the
          // one that must take the spinner down.
          this.syncSpinner();
        };
        img.src = item.imageUrl;
      });
    }

    /**
     * Resolves once `spread`'s image has either loaded, failed twice (once on the original URL,
     * once on a freshly re-fetched one), or a short timeout has elapsed — never rejects, and
     * never waits indefinitely, so a turn always starts ("never show an empty page… wait for
     * load or short timeout" — this is the "or"). On a load failure it re-GETs the status
     * endpoint exactly once per URL (signed URLs expire after 15 minutes) and retries with
     * whatever fresh URL that response has for the same spread number, then gives up.
     */
    loadImageWithRecovery(item) {
      return new Promise((resolve) => {
        if (!item || !item.imageUrl) {
          resolve();
          return;
        }

        const attempt = (imageUrl, allowRetry) => {
          if (this.preloadedUrls.has(imageUrl)) {
            resolve();
            return;
          }

          let settled = false;
          const finish = () => {
            if (settled) {
              return;
            }

            settled = true;
            window.clearTimeout(timer);
            resolve();
          };

          const timer = window.setTimeout(finish, IMAGE_READY_TIMEOUT_MS);
          const img = new Image();

          img.onload = () => {
            this.preloadedUrls.add(imageUrl);
            this.spreadDimensionsByUrl.set(imageUrl, { width: img.naturalWidth, height: img.naturalHeight });
            this.syncSpinner();
            finish();
          };

          img.onerror = () => {
            // TL13: mark BEFORE the branch below, not inside it. The two paths that give up
            // further down (a refresh that returns the same url, and a refresh that rejects)
            // both reach finish() without passing through here again, so marking only in the
            // give-up branch left the spinner running forever on the most ordinary real
            // failure there is -- an expired signed url whose refresh does not change it.
            // If the refresh DOES yield a new url, syncSpinner() keys off that new url, so
            // marking this dead one costs nothing.
            this.markImageFailed(imageUrl);

            if (settled || !allowRetry || this.retriedImageUrls.has(imageUrl)) {
              finish();
              return;
            }

            this.retriedImageUrls.add(imageUrl);

            this.refreshSpreadUrls()
              .then(() => {
                const refreshed = this.resolveItemByRef(item.kind, item.spreadNumber);

                if (settled) {
                  return;
                }

                if (refreshed && refreshed.imageUrl && refreshed.imageUrl !== imageUrl) {
                  window.clearTimeout(timer);
                  attempt(refreshed.imageUrl, false);
                } else {
                  finish();
                }
              })
              .catch(() => finish());
          };

          img.src = imageUrl;

          // TL13: covers the retry attempt too -- by now `item.imageUrl` is the refreshed url,
          // which is neither preloaded nor failed, so the spinner comes back up for it.
          this.syncSpinner();
        };

        attempt(item.imageUrl, true);
      });
    }

    /**
     * Re-GETs the status endpoint and, if it still reports awaiting_decision, replaces every
     * spread's data with the fresh copy by spreadNumber — deliberately *not* the full
     * applyStatusPayload() path, which would reset `currentIndex` to 0 and clear `this.notes`.
     * A signed-URL refresh must never lose the page the customer is on or what they already
     * typed.
     *
     * 2026-10-05: also refreshes `this.cover` (whole-object replace — the GET always returns the
     * complete cover or null, never a partial one) and rebuilds `this.items`, so "image recovery …
     * treats the cover as one more item" holds for a cover whose signed URL has expired mid-session
     * exactly as it already did for a spread's.
     */
    async refreshSpreadUrls() {
      let response;

      try {
        response = await fetch(this.buildStatusUrl(), { method: 'GET', headers: { Accept: 'application/json' } });
      } catch (error) {
        console.warn('[interior-proof] Spread URL refresh failed to send', { message: error?.message || null });
        return;
      }

      if (!response.ok) {
        return;
      }

      let payload;

      try {
        payload = await response.json();
      } catch (error) {
        return;
      }

      if (!payload || payload.status !== 'awaiting_decision' || !Array.isArray(payload.spreads)) {
        return;
      }

      const freshByNumber = new Map(payload.spreads.map((s) => [s.spreadNumber, s]));

      this.spreads = this.spreads.map((s) => freshByNumber.get(s.spreadNumber) || s);
      this.cover = payload.cover || null;
      this.rebuildItems();
    }

    /**
     * The public entry point for every turn source (Prev/Next, a pager number, arrow keys,
     * swipe). Implements two brief rules at once: a pager "jump" of more than one spread plays
     * exactly one turn straight to the target, never several; and a click that arrives while a
     * turn is already playing queues at most one more (the *first* such click — every one after
     * it is simply dropped, per spec).
     */
    requestTurn(targetIndex) {
      if (!this.items.length) {
        return;
      }

      const clamped = Math.max(0, Math.min(this.items.length - 1, targetIndex));

      // While a turn is in flight, `this.currentIndex` is still the *old* value — commitTurn()
      // only advances it once the animation ends. Comparing against the *effective* index (the
      // in-flight turn's own target, once one exists) instead is what makes "at most one more
      // turn" mean what it says: a second Next click 40ms after the first queues page N+2 (one
      // past where the first turn is already headed), not another turn to N+1 that would just
      // replay the one already running.
      const effectiveIndex = this.turning ? this.inFlightTargetIndex : this.currentIndex;

      if (clamped === effectiveIndex) {
        return;
      }

      if (this.turning) {
        if (this.pendingTargetIndex === null) {
          this.pendingTargetIndex = clamped;
        }

        return;
      }

      this.startTurn(clamped);
    }

    getEffectiveIndex() {
      return this.turning ? this.inFlightTargetIndex : this.currentIndex;
    }

    async startTurn(targetIndex) {
      const fromItem = this.items[this.currentIndex];
      const toItemRef = this.items[targetIndex];
      const toRefKind = toItemRef && toItemRef.kind;
      const toRefSpreadNumber = toItemRef && toItemRef.spreadNumber;
      const direction = targetIndex > this.currentIndex ? 'next' : 'prev';

      this.turning = true;
      this.inFlightTargetIndex = targetIndex;

      // Before the await below, not after: loadImageWithRecovery() can sit on the network for
      // its full timeout, and that wait is the whole reason this spinner exists.
      this.syncSpinner();

      if (this.pageTrigger) {
        this.pageTrigger.disabled = true;
      }

      await this.loadImageWithRecovery(toItemRef);

      // A refresh during the await above replaces array entries by identity — re-resolve the
      // target by its own identity (resolveItemByRef) rather than trusting the object reference
      // captured earlier. Works the same way for the cover as for a spread — see that method.
      const toItem = this.resolveItemByRef(toRefKind, toRefSpreadNumber) || this.items[targetIndex];

      // Applied *before* the turn plays, not after, so the book is already the right size for
      // the target when the turn starts — every spread shares one trim size in practice, so this
      // is normally a no-op for a spread-to-spread turn, but it's the structurally correct place
      // for it regardless, and it is NOT a no-op turning to or from the cover, whose aspect ratio
      // is its own (square, or the wraparound's ~1.97:1).
      this.updateSpreadRatio(toItem);

      if (this.prefersReducedMotion()) {
        this.playCrossfade(toItem, targetIndex);
      } else {
        this.playTurn(direction, fromItem, toItem, targetIndex);
      }
    }

    /**
     * The 3D turn. `direction` decides which half the flap covers and which way it rotates
     * (mirror images of each other, see the CSS comment above `.storefront-proof__book-flap`).
     * Sets both faces' content, reveals the *other* half underneath (the part of the target
     * spread that was never covered by the flap in the first place), forces a reflow so the
     * browser registers the flap's un-rotated starting state before animating, then adds the
     * `--turning` class on the next frame to trigger the CSS transition. commitTurn(), from
     * handleFlapTransitionEnd(), finishes the job once the transition ends.
     */
    playTurn(direction, fromItem, toItem, targetIndex) {
      if (!this.flapEl || !fromItem || !toItem) {
        this.finishTurn(toItem || fromItem, targetIndex);
        return;
      }

      const isNext = direction === 'next';

      this.flapEl.classList.remove('storefront-proof__book-flap--next', 'storefront-proof__book-flap--prev');
      this.flapEl.classList.add(isNext ? 'storefront-proof__book-flap--next' : 'storefront-proof__book-flap--prev');
      this.flapEl.hidden = false;
      this.flapEl.style.willChange = 'transform';
      this.flapEl.style.setProperty('--storefront-proof-turn-duration', this.getTurnDurationMs() + 'ms');

      this.setHalfBackground(this.flapFrontEl, fromItem.imageUrl, isNext ? '100% 0%' : '0% 0%');
      this.setHalfBackground(this.flapBackEl, toItem.imageUrl, isNext ? '0% 0%' : '100% 0%');

      // Reveal underneath: the half the flap is *not* covering updates to the target item right
      // away, hidden behind the flap's opaque front face until the flap turns away from it.
      if (isNext) {
        this.setHalfBackground(this.halfRightEl, toItem.imageUrl, '100% 0%');
      } else {
        this.setHalfBackground(this.halfLeftEl, toItem.imageUrl, '0% 0%');
      }

      this.pendingTurn = { direction, toSpread: toItem, targetIndex };

      // Force a reflow so the browser paints the flap at rotateY(0) before the `--turning` class
      // (added on the next frame) starts the transition — without this the browser can coalesce
      // both class changes into one paint and the turn never visibly animates.
      void this.flapEl.offsetWidth;

      requestAnimationFrame(() => {
        if (this.flapEl) {
          this.flapEl.classList.add('storefront-proof__book-flap--turning');
        }
      });
    }

    handleFlapTransitionEnd(event) {
      if (event.target !== this.flapEl || event.propertyName !== 'transform') {
        return;
      }

      this.commitTurn();
    }

    commitTurn() {
      const pending = this.pendingTurn;

      if (!pending) {
        return;
      }

      this.pendingTurn = null;

      this.flapEl.classList.remove('storefront-proof__book-flap--turning');
      this.flapEl.hidden = true;
      this.flapEl.style.willChange = '';

      this.finishTurn(pending.toSpread, pending.targetIndex);
    }

    /**
     * Reduced-motion path: a plain 150ms opacity crossfade to the full next spread (no rotation,
     * no flap), per the brief. Uses the crossfade layer's own `transitionend` rather than a bound
     * handler + pendingTurn, since only one of playTurn/playCrossfade is ever active per turn.
     */
    playCrossfade(toItem, targetIndex) {
      if (!this.crossfadeEl || !toItem) {
        this.finishTurn(toItem, targetIndex);
        return;
      }

      this.setHalfBackground(this.crossfadeEl, toItem.imageUrl, '0% 0%');
      this.crossfadeEl.style.backgroundSize = '100% 100%';
      this.crossfadeEl.hidden = false;
      this.crossfadeEl.style.willChange = 'opacity';
      this.crossfadeEl.classList.remove('storefront-proof__book-crossfade--visible');

      void this.crossfadeEl.offsetWidth;

      const onEnd = (event) => {
        if (event.target !== this.crossfadeEl || event.propertyName !== 'opacity') {
          return;
        }

        this.crossfadeEl.removeEventListener('transitionend', onEnd);
        this.crossfadeEl.classList.remove('storefront-proof__book-crossfade--visible');
        this.crossfadeEl.hidden = true;
        this.crossfadeEl.style.willChange = '';
        this.finishTurn(toItem, targetIndex);
      };

      this.crossfadeEl.addEventListener('transitionend', onEnd);

      requestAnimationFrame(() => {
        this.crossfadeEl.classList.add('storefront-proof__book-crossfade--visible');
      });
    }

    /**
     * Shared tail of both playTurn() (via commitTurn()) and playCrossfade(): lands the static
     * halves on the fully-new spread (matching exactly what was already visible an instant
     * earlier, so nothing pops), advances `currentIndex`, re-enables input, runs
     * afterSpreadChanged(), and — the whole point of pendingTargetIndex — immediately starts the
     * one queued turn, if a click asked for one while this turn was still playing.
     */
    finishTurn(toItem, targetIndex) {
      if (toItem) {
        this.setHalfBackground(this.halfLeftEl, toItem.imageUrl, '0% 0%');
        this.setHalfBackground(this.halfRightEl, toItem.imageUrl, '100% 0%');
      }

      this.currentIndex = targetIndex;
      this.turning = false;
      this.inFlightTargetIndex = null;

      if (this.pageTrigger) {
        this.pageTrigger.disabled = false;
      }

      this.afterSpreadChanged();

      if (this.pendingTargetIndex !== null) {
        const next = this.pendingTargetIndex;
        this.pendingTargetIndex = null;
        this.startTurn(next);
      }
    }

    handleViewerKeyDown(event) {
      if (event.key === 'ArrowRight') {
        event.preventDefault();
        this.requestTurn(this.getEffectiveIndex() + 1);
      } else if (event.key === 'ArrowLeft') {
        event.preventDefault();
        this.requestTurn(this.getEffectiveIndex() - 1);
      }
    }

    handleBookPointerDown(event) {
      if (event.pointerType === 'mouse' && event.button !== 0) {
        return;
      }

      this.swipeActive = true;
      this.swipeStartX = event.clientX;
      this.swipeStartY = event.clientY;
    }

    /**
     * The whole "vertical scroll must never trigger a turn" guarantee lives here: this handler
     * never calls preventDefault, not on pointerdown, not here, so the browser's own vertical
     * scroll is never interrupted while a gesture is in progress. The swipe is decided once,
     * after the fact, purely from the total distance and angle of the completed gesture — a
     * vertical scroll registers as a real drag with a mostly-vertical angle and is rejected by
     * the slope check below, exactly like a diagonal or a tap.
     */
    handleBookPointerUp(event) {
      if (!this.swipeActive) {
        return;
      }

      this.swipeActive = false;

      const dx = event.clientX - this.swipeStartX;
      const dy = event.clientY - this.swipeStartY;

      if (Math.abs(dx) < SWIPE_MIN_DISTANCE_PX || Math.abs(dx) <= Math.abs(dy) * SWIPE_MAX_SLOPE) {
        return;
      }

      this.requestTurn(this.getEffectiveIndex() + (dx < 0 ? 1 : -1));
    }

    handleBookPointerCancel() {
      this.swipeActive = false;
    }

    /**
     * 2026-10-05: one pill per item in `this.items`, cover included. The cover pill's visible
     * text is CHOSEN to be a single "C" — not the full word "Cover" — specifically to preserve
     * the 2026-09-28 fix #4 pager math unchanged: at the 1200px+ breakpoint every pill (including
     * this one) is forced to an explicit 36px width with no horizontal padding, sized to fit
     * exactly 12 numeric pills with no scrolling; a 5-letter pill at that width would either
     * clip or force the row back into scrolling/wrapping, reopening the overlap bug that fix
     * measured and closed. "Status shown by text, never by colour alone" is still satisfied — the
     * full word is in `aria-label`, read by assistive tech, same split every pager pill already
     * uses (digits are not self-explanatory either; `aria-label="Spread 4"` carries the meaning).
     */
    renderPagerNumbers() {
      if (!this.pagerEl) {
        return;
      }

      this.pagerEl.textContent = '';

      this.items.forEach((item, index) => {
        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'storefront-proof__pager-number';
        button.dataset.pageIndex = String(index);

        const isActive = index === this.currentIndex;
        const isCover = item.kind === 'cover';
        const hasNote = isCover ? this.hasCoverNote() : this.notes.has(item.spreadNumber);

        if (isActive) {
          button.classList.add('storefront-proof__pager-number--active');
          button.setAttribute('aria-current', 'true');
        }

        if (hasNote) {
          button.classList.add('storefront-proof__pager-number--marked');
        }

        button.textContent = isCover ? 'C' : String(item.spreadNumber);
        button.setAttribute(
          'aria-label',
          (isCover ? 'Cover' : 'Spread ' + item.spreadNumber) + (hasNote ? ', has a note' : '')
        );

        this.pagerEl.appendChild(button);
      });

      this.updatePagerOverflow();
    }

    /**
     * 2026-09-28 fix #5: "Add a soft fade at the edges when more pills exist" — the fade
     * (`.storefront-proof__pager-track--scrollable`, in CSS) only shows when the row actually
     * overflows, not unconditionally, and is hidden outright at 1024px+ where fix #4 makes every
     * pill fit without scrolling regardless of this class.
     */
    updatePagerOverflow() {
      if (!this.pagerTrackEl || !this.pagerEl) {
        return;
      }

      const isScrollable = this.pagerEl.scrollWidth > this.pagerEl.clientWidth + 1;
      this.pagerTrackEl.classList.toggle('storefront-proof__pager-track--scrollable', isScrollable);
    }

    /**
     * 2026-10-05: routes by item kind — a spread's text lives in `this.notes` (keyed by
     * spreadNumber, unchanged), the cover's lives in the separate `this.coverNote` string (see
     * that field's own comment for why it is not one more Map entry). Disabled (as before) when
     * there is no current item at all, and ALSO — new — when the current item is a cover whose
     * `notesAccepted` is false: product rule, "no note field on the cover" when the service hasn't
     * turned that on. The field is additionally hidden outright in that case
     * (updateCoverPresentation()); `disabled` here is defense in depth, not the only guard.
     */
    syncNoteTextarea() {
      if (!this.noteTextarea) {
        return;
      }

      const item = this.items[this.currentIndex];
      const isCover = !!(item && item.kind === 'cover');
      const text = item ? (isCover ? this.coverNote : this.notes.get(item.spreadNumber) || '') : '';

      this.noteTextarea.value = text;
      this.noteTextarea.disabled = !item || (isCover && !item.notesAccepted);
      this.updateNoteCounter();
    }

    updateNoteCounter() {
      if (!this.noteCounterEl || !this.noteTextarea) {
        return;
      }

      this.noteCounterEl.textContent = this.noteTextarea.value.length + ' / ' + NOTE_MAX_LENGTH;
    }

    handlePrevClick() {
      this.requestTurn(this.getEffectiveIndex() - 1);
    }

    handleNextClick() {
      this.requestTurn(this.getEffectiveIndex() + 1);
    }

    handlePagerClick(event) {
      const button = event.target.closest('[data-page-index]');

      if (!button) {
        return;
      }

      // A jump of more than one spread (e.g. 2 -> 7) plays exactly one turn straight to the
      // target — requestTurn()/startTurn() never step through the spreads in between.
      this.requestTurn(Number(button.dataset.pageIndex));
    }

    handlePageTriggerClick() {
      const item = this.items[this.currentIndex];

      if (!item) {
        return;
      }

      this.openLightbox(this.pageTrigger, item);
    }

    /**
     * 2026-10-05: doubles as the cover's "tap to zoom" — the hit-target button this opens from
     * (`.storefront-proof__book-hit`) already overlays the WHOLE book, cover included, so no
     * separate affordance was built; see the run report for the measured front-cover-half width
     * at 390px that this was weighed against.
     */
    openLightbox(opener, item) {
      this.lightboxOpener = opener;
      this.lightboxInner.textContent = '';

      // TASK TL3: a background-painted div, not an <img>, so the lightbox stops being the one
      // place on this page where "Save image as" still worked — the spreads behind it have
      // always been CSS backgrounds. Sized from the same width/height the <img> attributes
      // carried; see `.storefront-proof__lightbox-surface`.
      const surface = document.createElement('div');
      surface.className = 'storefront-proof__lightbox-surface';

      Protection.setProtectedBackground(surface, item.imageUrl, {
        label: item.kind === 'cover' ? 'Cover' : 'Spread ' + item.spreadNumber,
        width: item.width,
        height: item.height
      });

      this.lightboxInner.appendChild(surface);
      this.lightboxInner.appendChild(Protection.createShield(document));
      this.lightbox.showModal();
    }

    closeLightbox() {
      if (this.lightbox.open) {
        this.lightbox.close();
      }
    }

    handleLightboxClick(event) {
      // Clicking the dialog's own padding/backdrop area (never the image or the close
      // button, which stop propagation by being distinct targets) closes it — the same
      // "click outside the content" idiom as the two other dialogs on this page.
      if (event.target === this.lightbox) {
        this.closeLightbox();
      }
    }

    restoreFocusAfterLightbox() {
      if (this.lightboxOpener) {
        this.lightboxOpener.focus({ preventScroll: true });
      }

      this.lightboxOpener = null;
    }

    /**
     * A chip inserts its text into the current page's note (product brief, "Layout to build"):
     * appended after existing text with "; " as a separator, or set outright if the box is
     * empty. Not a replace — the customer may click more than one chip.
     */
    handleChipClick(event) {
      const chip = event.target.closest('[data-chip-text]');

      if (!chip || !this.noteTextarea) {
        return;
      }

      const chipText = chip.dataset.chipText;
      const current = this.noteTextarea.value.replace(/\s+$/, '');

      this.noteTextarea.value = current ? current + '; ' + chipText : chipText;
      this.noteTextarea.focus();
      this.handleNoteInput();
    }

    /**
     * Notes are kept per page, in memory only (product brief) — an empty/whitespace-only
     * textarea deletes that page's entry rather than storing a blank string, so
     * `this.notes.size` is exactly "how many pages actually have a note", which is what the
     * pager markers, the empty-notes hint and the Request-changes gating all read directly.
     *
     * 2026-10-05: routes to `this.coverNote` instead of the Map when the current item is the
     * cover — stored verbatim (not trimmed), same as a spread's note, so the textarea shows back
     * exactly what was typed; trimming only ever happens at the point each value is read for a
     * decision (hasCoverNote()-style checks below, and handleRejectSubmit()). Returns early,
     * untouched, if the cover's `notesAccepted` is false — defense in depth, since the field is
     * already hidden and disabled in that state (updateCoverPresentation(), syncNoteTextarea()).
     */
    handleNoteInput() {
      const item = this.items[this.currentIndex];

      if (!item) {
        return;
      }

      const isCover = item.kind === 'cover';

      if (isCover && !item.notesAccepted) {
        return;
      }

      const value = this.noteTextarea.value;

      if (isCover) {
        this.coverNote = value;
      } else if (value.trim()) {
        this.notes.set(item.spreadNumber, value);
      } else {
        this.notes.delete(item.spreadNumber);
      }

      this.updateNoteCounter();
      this.renderPagerNumbers();
      this.updateNotesEmptyHint();
      this.updateRequestChangesButtons();
      this.updateSendNotesCaveat();
      this.maybeAutoOpenNotes();
    }

    hasCoverNote() {
      return this.coverNote.trim().length > 0;
    }

    updateNotesEmptyHint() {
      if (this.notesEmptyEl) {
        this.notesEmptyEl.hidden = this.notes.size > 0 || this.hasCoverNote();
      }
    }

    /**
     * 2026-10-01 ("the proof side column matches the design"): single source of truth for
     * whether the collapsible is open — writes BOTH the toggle's `aria-expanded` and the panel's
     * `hidden` attribute, so the two can never read differently. Nothing else in this file
     * should set either of those two DOM properties directly; everywhere that needs to open or
     * close the panel calls this instead (handleNotesToggleClick(), maybeAutoOpenNotes(),
     * handleStickyRequestChangesClick(), and the reset in applyStatusPayload()).
     */
    setNotesOpen(open) {
      this.notesOpen = open;

      if (this.notesToggle) {
        this.notesToggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      }

      if (this.notesPanel) {
        this.notesPanel.hidden = !open;
      }
    }

    handleNotesToggleClick() {
      this.setNotesOpen(!this.notesOpen);
    }

    /**
     * "Collapsed by default; open by default when any page already has a note" (brief). CHOSEN
     * reading of "default": the initial/reset value (set to false in applyStatusPayload, where
     * `this.notes` is also freshly emptied), not a standing constraint fought back open on every
     * render regardless of what the customer just did — a customer who deliberately collapses it
     * after leaving a note is allowed to. So this only ever OPENS, the moment the note set first
     * becomes non-empty, and never closes anything itself. Called from handleNoteInput(), which
     * already runs on every chip click (via handleChipClick -> handleNoteInput) and every
     * keystroke.
     */
    maybeAutoOpenNotes() {
      if (this.notes.size > 0 && !this.notesOpen) {
        this.setNotesOpen(true);
      }
    }

    /**
     * "Request changes in the sticky bar scrolls to the collapsible and opens it; it does not
     * open the reject dialog directly" (brief). `redrawsLeft === 0` mirrors the same guard
     * handleRequestChangesClick() below has always had — the button is already genuinely
     * `disabled` in that state (updateRequestChangesButtons()), so a real click cannot reach
     * here, but this is the same defensive match, not a new rule. Focus lands on the toggle
     * itself once scrolled into view: enough to re-orient a keyboard user coming from the sticky
     * bar, without presuming they want the textarea focused too.
     */
    handleStickyRequestChangesClick() {
      if (this.redrawsLeft === 0 || !this.notesToggle) {
        return;
      }

      this.setNotesOpen(true);
      this.notesToggle.scrollIntoView({ behavior: 'smooth', block: 'start' });
      this.notesToggle.focus();
    }

    /**
     * "{left} of {total} redraws left" (brief, verbatim) — replaces the old
     * REDRAW_NOTED_PAGES_ONLY_COPY sentence THIS LINE used to open with; that real policy
     * information (only noted pages redraw) is not dropped, it is now the static
     * `.storefront-proof__notes-policy` paragraph in the Liquid markup, directly below "Notes
     * for spread N" — additive to the brief's own structure list, not a replacement of it (see
     * this task's report). Dots are gone outright (not in the design); `redrawsTotal` absent
     * falls back to a plain "{left} change(s) left", same condition as before, reworded.
     */
    updateRedrawsLine() {
      const hasTotal =
        typeof this.redrawsTotal === 'number' && Number.isFinite(this.redrawsTotal) && this.redrawsTotal > 0;
      const left = typeof this.redrawsLeft === 'number' ? this.redrawsLeft : 0;

      if (!this.regenLineEl) {
        return;
      }

      if (hasTotal) {
        this.regenLineEl.textContent = left + ' of ' + this.redrawsTotal + ' redraws left';
      } else {
        const changeWord = left === 1 ? 'change' : 'changes';
        this.regenLineEl.textContent = left + ' ' + changeWord + ' left';
      }
    }

    /**
     * "Notes on M spreads will be sent together." (CHOSEN copy, brief) — M is `this.notes.size`.
     * Hidden outright when M is 0, same [hidden] idiom the rest of this file already uses.
     *
     * 2026-10-05: CHOSEN extension, not specified by the brief, which is silent on this caveat —
     * when a cover note also exists, the sentence names it too rather than silently dropping it
     * (the cover note would otherwise be about to be sent with no on-page acknowledgement at
     * all). The spreads-only path below is untouched byte-for-byte from before this task.
     */
    updateSendNotesCaveat() {
      if (!this.notesCaveatEl) {
        return;
      }

      const spreadCount = this.notes.size;
      const hasCover = this.hasCoverNote();

      if (spreadCount === 0 && !hasCover) {
        this.notesCaveatEl.hidden = true;
        this.notesCaveatEl.textContent = '';
        return;
      }

      this.notesCaveatEl.hidden = false;

      if (hasCover && spreadCount > 0) {
        this.notesCaveatEl.textContent =
          'A note on the cover and ' + spreadCount + (spreadCount === 1 ? ' spread' : ' spreads') + ' will be sent together.';
      } else if (hasCover) {
        this.notesCaveatEl.textContent = 'A note on the cover will be sent.';
      } else {
        this.notesCaveatEl.textContent =
          'Notes on ' + spreadCount + (spreadCount === 1 ? ' spread' : ' spreads') + ' will be sent together.';
      }
    }

    /**
     * Reconciles two brief statements that only look contradictory: "the button is disabled
     * until at least one note exists" (Regenerations card) and "it opens the confirm step only
     * when at least one note exists; otherwise it scrolls or focuses the notes box" (product
     * rule #1). A truly `disabled` button never dispatches `click`, so it could never scroll or
     * focus anything — so "disabled" here means "styled inactive", via the `--muted` modifier,
     * while staying a real, focusable, clickable button. `redrawsLeft === 0` (product rule #5)
     * is the one genuine, unconditional disable: there is nothing this button can do then.
     *
     * 2026-10-01: styles BOTH buttons identically (the sticky-bar instance and the desktop Send
     * Notes instance) — only their CLICK behaviour differs now (see handleStickyRequestChangesClick
     * vs handleRequestChangesClick), their enabled/fallback-text state does not.
     */
    updateRequestChangesButtons() {
      const zeroLeft = this.redrawsLeft === 0;
      const hasNotes = this.notes.size > 0 || this.hasCoverNote();

      [this.requestChangesButton, this.sendNotesButton].filter(Boolean).forEach((button) => {
        if (zeroLeft) {
          button.textContent = 'Our team will help — reply to this email';
          button.disabled = true;
          button.classList.remove('storefront-proof__button--muted');
          return;
        }

        button.textContent = button === this.sendNotesButton ? 'Send notes' : 'Request changes';
        button.disabled = false;
        button.classList.toggle('storefront-proof__button--muted', !hasNotes);
      });
    }

    /**
     * Contract fix, 2026-09-29 (task "the spreads page sends its notes page by page"): the
     * dialog now opens with zero page notes too — a customer can reject with only free text,
     * not tied to any page. `buildCombinedComment()` returns '' in that case, so the textarea
     * opens blank; the existing 1-2000 char validity gate (updateRejectValidity) still requires
     * some text before Send enables. `redrawsLeft === 0` stays the one unconditional block.
     *
     * 2026-10-01: now only the desktop Send Notes button's handler — the sticky bar's own click
     * goes to handleStickyRequestChangesClick() instead. This function's body is otherwise
     * unchanged, per the brief ("which runs today's Request changes flow unchanged").
     */
    handleRequestChangesClick() {
      if (this.redrawsLeft === 0) {
        return;
      }

      this.rejectError.hidden = true;
      this.rejectError.textContent = '';
      this.rejectComment.value = this.buildCombinedComment();
      this.updateRejectValidity();
      this.updateRejectDialogCopy();
      this.rejectDialog.showModal();
    }

    /**
     * Names exactly which pages the pending reject will redraw, matching buildPageNotes() —
     * "Pages 4 and 7 will be redrawn" when notes exist, "The whole book will be redrawn." when
     * `this.notes` is empty (task point 4). The intro line above it is adjusted too: "one line
     * per page" is only true when there is at least one page note — with none, the textarea
     * opens blank and the customer is writing free text, not per-page lines. Set once, right
     * before the dialog opens; the background is inert while the dialog is modal, so
     * `this.notes` cannot change underneath it.
     *
     * 2026-10-05: `rejectIntroEl`'s "one line per page" check stays keyed to `pageNumbers.length`
     * alone, unchanged — the cover note is never folded into the textarea's per-page lines (it
     * travels as its own `coverNote` field, see handleRejectSubmit()), so claiming "one line per
     * page" when the only content is an invisible-in-this-box cover note would be misleading.
     * `rejectPagesLineEl` is CHOSEN to name the cover too, since that line is specifically about
     * redraw SCOPE, where omitting it would misstate what is about to happen. Not specified by
     * the brief; flagged in the run report. The no-cover-note branch is byte-for-byte unchanged.
     */
    updateRejectDialogCopy() {
      const pageNumbers = Array.from(this.notes.keys()).sort((a, b) => a - b);
      const hasPageNotes = pageNumbers.length > 0;
      const hasCover = this.hasCoverNote();

      if (this.rejectIntroEl) {
        this.rejectIntroEl.textContent = hasPageNotes
          ? "Here's what we'll send, one line per page. Feel free to edit it before sending."
          : "Here's what we'll send. Feel free to edit it before sending.";
      }

      if (this.rejectPagesLineEl) {
        if (!hasPageNotes && !hasCover) {
          this.rejectPagesLineEl.textContent = 'The whole book will be redrawn.';
        } else if (hasCover && hasPageNotes) {
          this.rejectPagesLineEl.textContent = 'The cover and ' + formatPagesList(pageNumbers) + ' will be redrawn.';
        } else if (hasCover) {
          this.rejectPagesLineEl.textContent = 'The cover will be redrawn.';
        } else {
          this.rejectPagesLineEl.textContent = formatPagesList(pageNumbers) + ' will be redrawn.';
        }
      }
    }

    /**
     * Product rule #2: "Build the comment body from all notes, oldest page first: `Page 3: …`,
     * one note per line." Oldest = lowest spreadNumber, regardless of viewing order.
     */
    buildCombinedComment() {
      const pageNumbers = Array.from(this.notes.keys()).sort((a, b) => a - b);

      return pageNumbers.map((pageNumber) => 'Page ' + pageNumber + ': ' + this.notes.get(pageNumber)).join('\n');
    }

    /**
     * `pageNotes` straight from the notes map, one entry per noted spread (task point 1) — built
     * independently of whatever the customer edited the combined `comment` textarea down to.
     * Returns `null`, not `[]`, when there are no page notes: the service's
     * `ValidationPipe({ whitelist: true, forbidNonWhitelisted: true })` accepts an absent field,
     * and the task brief says "send no pageNotes" for that case (point 4) — handleRejectSubmit
     * omits the key entirely rather than send an empty array.
     */
    buildPageNotes() {
      if (this.notes.size === 0) {
        return null;
      }

      return Array.from(this.notes.keys())
        .sort((a, b) => a - b)
        .map((spreadNumber) => ({ spreadNumber: spreadNumber, comment: this.notes.get(spreadNumber) }));
    }

    handleApproveTriggerClick() {
      this.approveError.hidden = true;
      this.approveError.textContent = '';
      this.approveDialog.showModal();
    }

    /**
     * THE DOUBLE-TAP GUARD. `button.disabled = true` runs synchronously, before the `await`,
     * so a second tap that lands before the first response arrives finds a disabled button and
     * never reaches this handler at all — browsers do not dispatch `click` on a disabled
     * button. The `if (this.approveInFlight) return` above it is a second, independent check
     * for the same thing, in case a future change ever calls this handler programmatically
     * instead of through a real disabled button.
     */
    async handleApproveConfirmClick() {
      if (this.approveInFlight) {
        return;
      }

      // TASK TL4, reworked 2026-10-13. Only the TRAP can stop an approval here. No
      // `enforceTime`: a parent who approves quickly must never have it silently discarded while
      // being shown the confirmation. The elapsed time is measured and sent, never enforced.
      // On a trap trip the customer sees exactly the confirmation a real approval produces.
      const trap = BotTrap.evaluate(this.root, Date.now());

      if (trap.ignore) {
        this.approveDialog.close();
        this.showConfirmationDialog(APPROVE_CONFIRMATION_TITLE, APPROVE_CONFIRMATION_TEXT, 'approved');
        return;
      }

      this.botTrapVerdict = trap;

      this.approveInFlight = true;
      this.approveConfirmButton.disabled = true;
      this.approveError.hidden = true;

      let response;

      try {
        response = await fetch(this.buildActionUrl('approve'), { method: 'POST' });
      } catch (error) {
        console.warn('[interior-proof] Approve request failed to send', { message: error?.message || null });
        this.showApproveError("We couldn't reach the server. Please try again.");
        return;
      } finally {
        this.approveInFlight = false;
        this.approveConfirmButton.disabled = false;
      }

      if (response.status === 409) {
        this.approveDialog.close();
        this.checkStatus();
        return;
      }

      // ADDENDUM guard, 2026-09-29: "when the service answers 401/403 for it" — cleanup only,
      // does not change which message shows below.
      if (response.status === 401 || response.status === 403) {
        this.clearStoredToken();
      }

      if (!response.ok) {
        console.warn('[interior-proof] Approve request rejected', { status: response.status });
        this.showApproveError("We couldn't send your approval. Please try again.");
        return;
      }

      let payload;

      try {
        payload = await response.json();
      } catch (error) {
        payload = null;
      }

      this.approveDialog.close();

      if (payload && KNOWN_STATUSES.includes(payload.status)) {
        this.showConfirmationDialog(APPROVE_CONFIRMATION_TITLE, APPROVE_CONFIRMATION_TEXT, payload.status);
      } else {
        this.checkStatus();
      }
    }

    showApproveError(message) {
      this.approveError.textContent = message;
      this.approveError.hidden = false;
    }

    /**
     * Product rule, 2026-09-28: "reject always needs one." Recomputes the counter text and the
     * send button's disabled state on every keystroke; also called when the confirm dialog opens
     * (pre-filled from buildCombinedComment(), so normally already valid) and in
     * handleRejectSubmit's finally block (to restore the right enabled state once
     * `rejectInFlight` goes back to false, instead of unconditionally re-enabling a button whose
     * text might still be invalid).
     */
    updateRejectValidity() {
      const trimmedLength = this.rejectComment.value.trim().length;
      const isValid = trimmedLength >= 1 && trimmedLength <= REJECT_COMMENT_MAX_LENGTH;

      this.rejectCounter.textContent = trimmedLength + ' / ' + REJECT_COMMENT_MAX_LENGTH;
      this.rejectCounter.classList.toggle('storefront-proof__counter--invalid', trimmedLength === 0);
      this.rejectSendButton.disabled = !isValid || this.rejectInFlight;

      return isValid;
    }

    handleRejectCommentInput() {
      this.updateRejectValidity();
    }

    /**
     * Same guard shape as approve — see the comment on handleApproveConfirmClick(). The
     * `!this.updateRejectValidity()` check is defensive, not the primary gate — the primary gate
     * is the send button's own `disabled` state, which a real click cannot bypass — in case a
     * future change ever calls this handler programmatically instead of through a real button.
     * One request only (product rule #2): everything already went into buildCombinedComment()
     * before this dialog opened, so this sends exactly once, however many pages have a note.
     */
    async handleRejectSubmit(event) {
      event.preventDefault();

      if (this.rejectInFlight || !this.updateRejectValidity()) {
        return;
      }

      // TASK TL4 — same rule and same reasoning as handleApproveConfirmClick(): trap enforced,
      // time measured and sent but never used to refuse.
      const trap = BotTrap.evaluate(this.root, Date.now());

      if (trap.ignore) {
        this.rejectDialog.close();
        this.showConfirmationDialog(REJECT_CONFIRMATION_TITLE, REJECT_CONFIRMATION_TEXT, 'rejected_redrawing');
        return;
      }

      this.botTrapVerdict = trap;

      this.rejectInFlight = true;
      this.rejectSendButton.disabled = true;
      this.rejectError.hidden = true;

      const comment = this.rejectComment.value.trim();
      const pageNotes = this.buildPageNotes();
      const trimmedCoverNote = this.coverNote.trim();
      // Exactly { comment }, plus pageNotes and/or coverNote only when each actually has content —
      // the service 400s on any unexpected key (task point 5: `forbidNonWhitelisted: true`), so
      // no field is ever sent empty or absent-but-present. `cover.notesAccepted` is checked again
      // here even though the UI already prevents typing a cover note otherwise (syncNoteTextarea(),
      // handleNoteInput()) — defense in depth, same style as the rest of this file.
      const body = { comment: comment };

      if (pageNotes) {
        body.pageNotes = pageNotes;
      }

      if (trimmedCoverNote && this.cover && this.cover.notesAccepted) {
        body.coverNote = trimmedCoverNote;
      }

      let response;

      try {
        response = await fetch(this.buildActionUrl('reject'), {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(body)
        });
      } catch (error) {
        console.warn('[interior-proof] Reject request failed to send', { message: error?.message || null });
        this.showRejectError("We couldn't reach the server. Please try again.");
        return;
      } finally {
        this.rejectInFlight = false;
        this.updateRejectValidity();
      }

      if (response.status === 409) {
        this.rejectDialog.close();
        this.checkStatus();
        return;
      }

      // ADDENDUM guard, 2026-09-29: "when the service answers 401/403 for it" — cleanup only,
      // does not change which message shows below.
      if (response.status === 401 || response.status === 403) {
        this.clearStoredToken();
      }

      // 400 means the server-side "reject always needs one" check rejected the comment — the
      // client-side check above should make this unreachable in practice, but the contract lists
      // it explicitly, so it gets its own message rather than falling into the generic branch
      // below. The typed text is left exactly as it was: no `.value = ''`, no `.close()`.
      if (response.status === 400) {
        let payload = null;

        try {
          payload = await response.json();
        } catch (error) {
          payload = null;
        }

        console.warn('[interior-proof] Reject request rejected as invalid', { status: 400 });
        this.showRejectError((payload && payload.message) || 'Please tell us what to change.');
        return;
      }

      if (!response.ok) {
        console.warn('[interior-proof] Reject request rejected', { status: response.status });
        this.showRejectError("We couldn't send this. Please try again.");
        return;
      }

      let payload;

      try {
        payload = await response.json();
      } catch (error) {
        payload = null;
      }

      this.rejectDialog.close();

      if (payload && KNOWN_STATUSES.includes(payload.status)) {
        this.showConfirmationDialog(REJECT_CONFIRMATION_TITLE, REJECT_CONFIRMATION_TEXT, payload.status);
      } else {
        this.checkStatus();
      }
    }

    showRejectError(message) {
      this.rejectError.textContent = message;
      this.rejectError.hidden = false;
    }

    handleRetryClick() {
      this.checkStatus();
    }

    handleWindowResize() {
      if (this.resizeTimer) {
        window.clearTimeout(this.resizeTimer);
      }

      this.resizeTimer = window.setTimeout(() => {
        this.resizeTimer = null;
        this.updatePagerOverflow();
      }, 150);
    }
  }

  function init() {
    const root = document.querySelector(ROOT_SELECTOR);

    if (!root) {
      return;
    }

    new InteriorProofPage(root);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
